import { GetterTree, ActionTree } from 'vuex';
import { PersistentStore } from '@/utils/PersistentStore';
import { replaceInArray } from '@/utils/Array';

import vuestore from '@/store';
import { domainService } from '../services/domainService';
import { CreateTypedStoreProxy } from 'vuex-typed-store';

export interface DomainStoreModel { }

export interface DomainStoreActions {
  setComposizioneVegetazionale(datas: domains.domini[]): Promise<void>;
  setDanniOsservati(levels: domains.domini[]): Promise<void>;
  setEsposizione(levels: domains.domini[]): Promise<void>;
  setFeriteTroncoCicatrizzazione(levels: domains.domini[]): Promise<void>;
  setFeriteTroncoDimensioni(levels: domains.domini[]): Promise<void>;
  setFustiFibratura(levels: domains.domini[]): Promise<void>;
  setFustiNodosita(levels: domains.domini[]): Promise<void>;
  setFustiSezione(levels: domains.domini[]): Promise<void>;
  setFustiTipo(levels: domains.domini[]): Promise<void>;
  setGiaciture(levels: domains.domini[]): Promise<void>;
  setGoverni(levels: domains.domini[]): Promise<void>;
  setLettiere(levels: domains.domini[]): Promise<void>;
  setOrigineMaterialiSelezionati(levels: domains.domini[]): Promise<void>;
  setOriginePiantePlus(levels: domains.domini[]): Promise<void>;
  setOriginePopolamentiForestali(levels: domains.domini[]): Promise<void>;
  setPietrosita(levels: domains.domini[]): Promise<void>;
  setPosizioniPiantePlus(levels: domains.domini[]): Promise<void>;
  setPotaturePiantePlus(levels: domains.domini[]): Promise<void>;
  setSpecieArboree(levels: domains.domini[]): Promise<void>;
  setStruttureOrizzontali(levels: domains.domini[]): Promise<void>;
  setStruttureVerticali(levels: domains.domini[]): Promise<void>;
  setSubstratiPetrogenici(levels: domains.domini[]): Promise<void>;
  setTerreniSottostanti(levels: domains.domini[]): Promise<void>;
  setTipiPiantePlus(levels: domains.domini[]): Promise<void>;
  setTipiPianteSemeMarze(levels: domains.domini[]): Promise<void>;
  setTrattamenti(levels: domains.domini[]): Promise<void>;
  setUbicazioni(levels: domains.domini[]): Promise<void>;
  setStatiVegetativi(levels: domains.domini[]): Promise<void>;
}

export interface DomainStoreGetters {
  composizioneVegetazionale(id: number): Promise<domains.domini>;
  composizioneVegetazionali(): Promise<domains.domini[]>;

  dannoOsservato(value: number): Promise<domains.domini>;
  danniOsservati(): Promise<domains.domini[]>;

  esposizione(value: number): Promise<domains.domini>;
  esposizioni(): Promise<domains.domini[]>;

  feritaTroncoCicatrizzazione(value: number): Promise<domains.domini>;
  feriteTroncoCicatrizzazione(): Promise<domains.domini[]>;

  feritaTroncoDimensioni(value: number): Promise<domains.domini>;
  feriteTroncoDimensioni(): Promise<domains.domini[]>;

  fustoFibratura(value: number): Promise<domains.domini>;
  fustiFibratura(): Promise<domains.domini[]>;

  fustoNodosita(value: number): Promise<domains.domini>;
  fustiNodosita(): Promise<domains.domini[]>;

  fustoSezione(value: number): Promise<domains.domini>;
  fustiSezione(): Promise<domains.domini[]>;

  fustoTipo(value: number): Promise<domains.domini>;
  fustiTipo(): Promise<domains.domini[]>;

  giacitura(value: number): Promise<domains.domini>;
  giaciture(): Promise<domains.domini[]>;

  governo(value: number): Promise<domains.domini>;
  governi(): Promise<domains.domini[]>;

  lettiera(value: number): Promise<domains.domini>;
  lettiere(): Promise<domains.domini[]>;

  origineMaterialeSelezionato(value: number): Promise<domains.domini>;
  origineMaterialiSelezionati(): Promise<domains.domini[]>;

  originePiantaPlus(value: number): Promise<domains.domini>;
  originePiantePlus(): Promise<domains.domini[]>;

  originePopolamentoForestale(value: number): Promise<domains.domini>;
  originePopolamentiForestali(): Promise<domains.domini[]>;

  pietrositaByValue(value: number): Promise<domains.domini>;
  pietrosita(): Promise<domains.domini[]>;

  posizionePiantaPlus(value: number): Promise<domains.domini>;
  posizioniPiantePlus(): Promise<domains.domini[]>;

  potaturaPiantaPlus(value: number): Promise<domains.domini>;
  potaturePiantePlus(): Promise<domains.domini[]>;

  specieArborea(value: number): Promise<domains.domini>;
  specieArboree(): Promise<domains.domini[]>;

  strutturaOrizzontale(value: number): Promise<domains.domini>;
  struttureOrizzontali(): Promise<domains.domini[]>;

  strutturaVerticale(value: number): Promise<domains.domini>;
  struttureVerticali(): Promise<domains.domini[]>;

  substratoPetrogenico(value: number): Promise<domains.domini>;
  substratiPetrogenici(): Promise<domains.domini[]>;

  terrenoSottostante(value: number): Promise<domains.domini>;
  terreniSottostanti(): Promise<domains.domini[]>;

  tipoPiantaPlus(value: number): Promise<domains.domini>;
  tipiPiantePlus(): Promise<domains.domini[]>;

  tipoPiantaSemeMarze(value: number): Promise<domains.domini>;
  tipiPianteSemeMarze(): Promise<domains.domini[]>;

  trattamento(value: number): Promise<domains.domini>;
  trattamenti(): Promise<domains.domini[]>;

  ubicazione(value: number): Promise<domains.domini>;
  ubicazioni(): Promise<domains.domini[]>;

  statoVegetativo(value: number): Promise<domains.domini>;
  statiVegetativi(): Promise<domains.domini[]>;
}

export const TABLES = {
  composizioneVegetazionale: 'domain.composizioneVegetazionale',
  danniOsservati: 'domain.danniOsservati',
  esposizioni: 'domain.esposizioni',
  feriteTroncoCicatrizzazione: 'domain.feriteTroncoCicatrizzazione',
  feriteTroncoDimensioni: 'domain.feriteTroncoDimensioni',
  fustiFibratura: 'domain.fustiFibratura',
  fustiNodosita: 'domain.fustiNodosita',
  fustiSezione: 'domain.fustiSezione',
  fustiTipo: 'domain.fustiTipo',
  giaciture: 'domain.giaciture',
  governi: 'domain.governi',
  lettiere: 'domain.lettiere',
  origineMaterialiSelezionati: 'domain.origineMaterialiSelezionati',
  originePiantePlus: 'domain.originePiantePlus',
  originePopolamentiForestali: 'domain.originePopolamentiForestali',
  pietrosita: 'domain.pietrosita',
  posizioniPiantePlus: 'domain.posizioniPiantePlus',
  potaturePiantePlus: 'domain.potaturePiantePlus',
  specieArboree: 'domain.specieArboree',
  struttureOrizzontali: 'domain.struttureOrizzontali',
  struttureVerticali: 'domain.struttureVerticali',
  substratiPetrogenici: 'domain.substratiPetrogenici',
  terreniSottostanti: 'domain.terreniSottostanti',
  tipiPiantePlus: 'domain.tipiPiantePlus',
  tipiPianteSemeMarze: 'domain.tipiPianteSemeMarze',
  trattamenti: 'domain.trattamenti',
  ubicazioni: 'domain.ubicazioni',
  statiVegetativi: 'domain.statiVegetativi'
};

export const DomainStore = {
  PREFIX: 'domain',
  namespaced: true,
  mutations: {},
  getters: {
    composizioneVegetazionale: (state) => async (id: number): Promise<domains.domini> => {
      return await PersistentStore.get<domains.domini>(TABLES.composizioneVegetazionale, id);
    },
    composizioneVegetazionali: (state) => async (): Promise<domains.domini[]> => {
      const result: domains.domini[] = await PersistentStore.getAll<domains.domini>(TABLES.composizioneVegetazionale) || [];
      const maxts: number = await PersistentStore.getMaxTs(TABLES.composizioneVegetazionale);
      domainService.getComposizioneVegetazionale(maxts).then(async r => {
        replaceInArray(r, result, (a, b) => a.id === b.id);
        await PersistentStore.set(TABLES.composizioneVegetazionale, r);
      });
      return result;
    },

    dannoOsservato: (state) => async (id: number): Promise<domains.domini> => {
      return await PersistentStore.get<domains.domini>(TABLES.danniOsservati, id);
    },
    danniOsservati: (state) => async (): Promise<domains.domini[]> => {
      const result: domains.domini[] = await PersistentStore.getAll<domains.domini>(TABLES.danniOsservati) || [];
      const maxts: number = await PersistentStore.getMaxTs(TABLES.danniOsservati);
      domainService.getDanniOsservati(maxts).then(async r => {
        replaceInArray(r, result, (a, b) => a.id === b.id);
        await PersistentStore.set(TABLES.danniOsservati, r);
      });
      return result;
    },

    esposizione: (state) => async (id: number): Promise<domains.domini> => {
      return await PersistentStore.get<domains.domini>(TABLES.esposizioni, id);
    },
    esposizioni: (state) => async (): Promise<domains.domini[]> => {
      const result: domains.domini[] = await PersistentStore.getAll<domains.domini>(TABLES.esposizioni) || [];
      const maxts: number = await PersistentStore.getMaxTs(TABLES.esposizioni);
      domainService.getEsposizione(maxts).then(async r => {
        replaceInArray(r, result, (a, b) => a.id === b.id);
        await PersistentStore.set(TABLES.esposizioni, r);
      });
      return result;
    },

    feritaTroncoCicatrizzazione: (state) => async (id: number): Promise<domains.domini> => {
      return await PersistentStore.get<domains.domini>(TABLES.feriteTroncoCicatrizzazione, id);
    },
    feriteTroncoCicatrizzazione: (state) => async (): Promise<domains.domini[]> => {
      const result: domains.domini[] = await PersistentStore.getAll<domains.domini>(TABLES.feriteTroncoCicatrizzazione) || [];
      const maxts: number = await PersistentStore.getMaxTs(TABLES.feriteTroncoCicatrizzazione);
      domainService.getFeriteTroncoCicatrizzazione(maxts).then(async r => {
        replaceInArray(r, result, (a, b) => a.id === b.id);
        await PersistentStore.set(TABLES.feriteTroncoCicatrizzazione, r);
      });
      return result;
    },

    feritaTroncoDimensioni: (state) => async (id: number): Promise<domains.domini> => {
      return await PersistentStore.get<domains.domini>(TABLES.feriteTroncoDimensioni, id);
    },
    feriteTroncoDimensioni: (state) => async (): Promise<domains.domini[]> => {
      const result: domains.domini[] = await PersistentStore.getAll<domains.domini>(TABLES.feriteTroncoDimensioni) || [];
      const maxts: number = await PersistentStore.getMaxTs(TABLES.feriteTroncoDimensioni);
      domainService.getFeriteTroncoDimensioni(maxts).then(async r => {
        replaceInArray(r, result, (a, b) => a.id === b.id);
        await PersistentStore.set(TABLES.feriteTroncoDimensioni, r);
      });
      return result;
    },

    fustoFibratura: (state) => async (id: number): Promise<domains.domini> => {
      return await PersistentStore.get<domains.domini>(TABLES.fustiFibratura, id);
    },
    fustiFibratura: (state) => async (): Promise<domains.domini[]> => {
      const result: domains.domini[] = await PersistentStore.getAll<domains.domini>(TABLES.fustiFibratura) || [];
      const maxts: number = await PersistentStore.getMaxTs(TABLES.fustiFibratura);
      domainService.getFustoFibratura(maxts).then(async r => {
        replaceInArray(r, result, (a, b) => a.id === b.id);
        await PersistentStore.set(TABLES.fustiFibratura, r);
      });
      return result;
    },

    fustoNodosita: (state) => async (id: number): Promise<domains.domini> => {
      return await PersistentStore.get<domains.domini>(TABLES.fustiNodosita, id);
    },
    fustiNodosita: (state) => async (): Promise<domains.domini[]> => {
      const result: domains.domini[] = await PersistentStore.getAll<domains.domini>(TABLES.fustiNodosita) || [];
      const maxts: number = await PersistentStore.getMaxTs(TABLES.fustiNodosita);
      domainService.getFustoNodosita(maxts).then(async r => {
        replaceInArray(r, result, (a, b) => a.id === b.id);
        await PersistentStore.set(TABLES.fustiNodosita, r);
      });
      return result;
    },

    fustoSezione: (state) => async (id: number): Promise<domains.domini> => {
      return await PersistentStore.get<domains.domini>(TABLES.fustiSezione, id);
    },
    fustiSezione: (state) => async (): Promise<domains.domini[]> => {
      const result: domains.domini[] = await PersistentStore.getAll<domains.domini>(TABLES.fustiSezione) || [];
      const maxts: number = await PersistentStore.getMaxTs(TABLES.fustiSezione);
      domainService.getFustoSezione(maxts).then(async r => {
        replaceInArray(r, result, (a, b) => a.id === b.id);
        await PersistentStore.set(TABLES.fustiSezione, r);
      });
      return result;
    },

    fustoTipo: (state) => async (id: number): Promise<domains.domini> => {
      return await PersistentStore.get<domains.domini>(TABLES.fustiTipo, id);
    },
    fustiTipo: (state) => async (): Promise<domains.domini[]> => {
      const result: domains.domini[] = await PersistentStore.getAll<domains.domini>(TABLES.fustiTipo) || [];
      const maxts: number = await PersistentStore.getMaxTs(TABLES.fustiTipo);
      domainService.getFustoTipo(maxts).then(async r => {
        replaceInArray(r, result, (a, b) => a.id === b.id);
        await PersistentStore.set(TABLES.fustiTipo, r);
      });
      return result;
    },

    giacitura: (state) => async (id: number): Promise<domains.domini> => {
      return await PersistentStore.get<domains.domini>(TABLES.giaciture, id);
    },
    giaciture: (state) => async (): Promise<domains.domini[]> => {
      const result: domains.domini[] = await PersistentStore.getAll<domains.domini>(TABLES.giaciture) || [];
      const maxts: number = await PersistentStore.getMaxTs(TABLES.giaciture);
      domainService.getGiacitura(maxts).then(async r => {
        replaceInArray(r, result, (a, b) => a.id === b.id);
        await PersistentStore.set(TABLES.giaciture, r);
      });
      return result;
    },

    governo: (state) => async (id: number): Promise<domains.domini> => {
      return await PersistentStore.get<domains.domini>(TABLES.governi, id);
    },
    governi: (state) => async (): Promise<domains.domini[]> => {
      const result: domains.domini[] = await PersistentStore.getAll<domains.domini>(TABLES.governi) || [];
      const maxts: number = await PersistentStore.getMaxTs(TABLES.governi);
      domainService.getGoverno(maxts).then(async r => {
        replaceInArray(r, result, (a, b) => a.id === b.id);
        await PersistentStore.set(TABLES.governi, r);
      });
      return result;
    },

    lettiera: (state) => async (id: number): Promise<domains.domini> => {
      return await PersistentStore.get<domains.domini>(TABLES.lettiere, id);
    },
    lettiere: (state) => async (): Promise<domains.domini[]> => {
      const result: domains.domini[] = await PersistentStore.getAll<domains.domini>(TABLES.lettiere) || [];
      const maxts: number = await PersistentStore.getMaxTs(TABLES.lettiere);
      domainService.getLettiera(maxts).then(async r => {
        replaceInArray(r, result, (a, b) => a.id === b.id);
        await PersistentStore.set(TABLES.lettiere, r);
      });
      return result;
    },

    origineMaterialeSelezionato: (state) => async (id: number): Promise<domains.domini> => {
      return await PersistentStore.get<domains.domini>(TABLES.origineMaterialiSelezionati, id);
    },
    origineMaterialiSelezionati: (state) => async (): Promise<domains.domini[]> => {
      const result: domains.domini[] = await PersistentStore.getAll<domains.domini>(TABLES.origineMaterialiSelezionati) || [];
      const maxts: number = await PersistentStore.getMaxTs(TABLES.origineMaterialiSelezionati);
      domainService.getOrigineMaterialeSelezionato(maxts).then(async r => {
        replaceInArray(r, result, (a, b) => a.id === b.id);
        await PersistentStore.set(TABLES.origineMaterialiSelezionati, r);
      });
      return result;
    },

    originePiantaPlus: (state) => async (id: number): Promise<domains.domini> => {
      return await PersistentStore.get<domains.domini>(TABLES.originePiantePlus, id);
    },
    originePiantePlus: (state) => async (): Promise<domains.domini[]> => {
      const result: domains.domini[] = await PersistentStore.getAll<domains.domini>(TABLES.originePiantePlus) || [];
      const maxts: number = await PersistentStore.getMaxTs(TABLES.originePiantePlus);
      domainService.getOriginePiantePlus(maxts).then(async r => {
        replaceInArray(r, result, (a, b) => a.id === b.id);
        await PersistentStore.set(TABLES.originePiantePlus, r);
      });
      return result;
    },

    originePopolamentoForestale: (state) => async (id: number): Promise<domains.domini> => {
      return await PersistentStore.get<domains.domini>(TABLES.originePopolamentiForestali, id);
    },
    originePopolamentiForestali: (state) => async (): Promise<domains.domini[]> => {
      const result: domains.domini[] = await PersistentStore.getAll<domains.domini>(TABLES.originePopolamentiForestali) || [];
      const maxts: number = await PersistentStore.getMaxTs(TABLES.originePopolamentiForestali);
      domainService.getOriginePopolamentoForestale(maxts).then(async r => {
        replaceInArray(r, result, (a, b) => a.id === b.id);
        await PersistentStore.set(TABLES.originePopolamentiForestali, r);
      });
      return result;
    },

    pietrositaByValue: (state) => async (id: number): Promise<domains.domini> => {
      return await PersistentStore.get<domains.domini>(TABLES.pietrosita, id);
    },
    pietrosita: (state) => async (): Promise<domains.domini[]> => {
      const result: domains.domini[] = await PersistentStore.getAll<domains.domini>(TABLES.pietrosita) || [];
      const maxts: number = await PersistentStore.getMaxTs(TABLES.pietrosita);
      domainService.getPietrosita(maxts).then(async r => {
        replaceInArray(r, result, (a, b) => a.id === b.id);
        await PersistentStore.set(TABLES.pietrosita, r);
      });
      return result;
    },

    posizionePiantaPlus: (state) => async (id: number): Promise<domains.domini> => {
      return await PersistentStore.get<domains.domini>(TABLES.posizioniPiantePlus, id);
    },
    posizioniPiantePlus: (state) => async (): Promise<domains.domini[]> => {
      const result: domains.domini[] = await PersistentStore.getAll<domains.domini>(TABLES.posizioniPiantePlus) || [];
      const maxts: number = await PersistentStore.getMaxTs(TABLES.posizioniPiantePlus);
      domainService.getPosizionePiantePlus(maxts).then(async r => {
        replaceInArray(r, result, (a, b) => a.id === b.id);
        await PersistentStore.set(TABLES.posizioniPiantePlus, r);
      });
      return result;
    },

    potaturaPiantaPlus: (state) => async (id: number): Promise<domains.domini> => {
      return await PersistentStore.get<domains.domini>(TABLES.potaturePiantePlus, id);
    },
    potaturePiantePlus: (state) => async (): Promise<domains.domini[]> => {
      const result: domains.domini[] = await PersistentStore.getAll<domains.domini>(TABLES.potaturePiantePlus) || [];
      const maxts: number = await PersistentStore.getMaxTs(TABLES.potaturePiantePlus);
      domainService.getPotaturaPiantePlus(maxts).then(async r => {
        replaceInArray(r, result, (a, b) => a.id === b.id);
        await PersistentStore.set(TABLES.potaturePiantePlus, r);
      });
      return result;
    },

    specieArborea: (state) => async (id: number): Promise<domains.domini> => {
      return await PersistentStore.get<domains.domini>(TABLES.specieArboree, id);
    },
    specieArboree: (state) => async (): Promise<domains.domini[]> => {
      const result: domains.domini[] = await PersistentStore.getAll<domains.domini>(TABLES.specieArboree) || [];
      const maxts: number = await PersistentStore.getMaxTs(TABLES.specieArboree);
      domainService.getSpecieArboree(maxts).then(async r => {
        replaceInArray(r, result, (a, b) => a.id === b.id);
        await PersistentStore.set(TABLES.specieArboree, r);
      });
      return result;
    },

    strutturaOrizzontale: (state) => async (id: number): Promise<domains.domini> => {
      return await PersistentStore.get<domains.domini>(TABLES.struttureOrizzontali, id);
    },
    struttureOrizzontali: (state) => async (): Promise<domains.domini[]> => {
      const result: domains.domini[] = await PersistentStore.getAll<domains.domini>(TABLES.struttureOrizzontali) || [];
      const maxts: number = await PersistentStore.getMaxTs(TABLES.struttureOrizzontali);
      domainService.getStrutturaOrizzontale(maxts).then(async r => {
        replaceInArray(r, result, (a, b) => a.id === b.id);
        await PersistentStore.set(TABLES.struttureOrizzontali, r);
      });
      return result;
    },

    strutturaVerticale: (state) => async (id: number): Promise<domains.domini> => {
      return await PersistentStore.get<domains.domini>(TABLES.struttureVerticali, id);
    },
    struttureVerticali: (state) => async (): Promise<domains.domini[]> => {
      const result: domains.domini[] = await PersistentStore.getAll<domains.domini>(TABLES.struttureVerticali) || [];
      const maxts: number = await PersistentStore.getMaxTs(TABLES.struttureVerticali);
      domainService.getStrutturaVerticale(maxts).then(async r => {
        replaceInArray(r, result, (a, b) => a.id === b.id);
        await PersistentStore.set(TABLES.struttureVerticali, r);
      });
      return result;
    },

    substratoPetrogenico: (state) => async (id: number): Promise<domains.domini> => {
      return await PersistentStore.get<domains.domini>(TABLES.substratiPetrogenici, id);
    },
    substratiPetrogenici: (state) => async (): Promise<domains.domini[]> => {
      const result: domains.domini[] = await PersistentStore.getAll<domains.domini>(TABLES.substratiPetrogenici) || [];
      const maxts: number = await PersistentStore.getMaxTs(TABLES.substratiPetrogenici);
      domainService.getSubstratoPetrogenico(maxts).then(async r => {
        replaceInArray(r, result, (a, b) => a.id === b.id);
        await PersistentStore.set(TABLES.substratiPetrogenici, r);
      });
      return result;
    },

    terrenoSottostante: (state) => async (id: number): Promise<domains.domini> => {
      return await PersistentStore.get<domains.domini>(TABLES.terreniSottostanti, id);
    },
    terreniSottostanti: (state) => async (): Promise<domains.domini[]> => {
      const result: domains.domini[] = await PersistentStore.getAll<domains.domini>(TABLES.terreniSottostanti) || [];
      const maxts: number = await PersistentStore.getMaxTs(TABLES.terreniSottostanti);
      domainService.getTerrenoSottostante(maxts).then(async r => {
        replaceInArray(r, result, (a, b) => a.id === b.id);
        await PersistentStore.set(TABLES.terreniSottostanti, r);
      });
      return result;
    },

    tipoPiantaPlus: (state) => async (id: number): Promise<domains.domini> => {
      return await PersistentStore.get<domains.domini>(TABLES.tipiPiantePlus, id);
    },
    tipiPiantePlus: (state) => async (): Promise<domains.domini[]> => {
      const result: domains.domini[] = await PersistentStore.getAll<domains.domini>(TABLES.tipiPiantePlus) || [];
      const maxts: number = await PersistentStore.getMaxTs(TABLES.tipiPiantePlus);
      domainService.getTipoPiantePlus(maxts).then(async r => {
        replaceInArray(r, result, (a, b) => a.id === b.id);
        await PersistentStore.set(TABLES.tipiPiantePlus, r);
      });
      return result;
    },

    tipoPiantaSemeMarze: (state) => async (id: number): Promise<domains.domini> => {
      return await PersistentStore.get<domains.domini>(TABLES.tipiPianteSemeMarze, id);
    },
    tipiPianteSemeMarze: (state) => async (): Promise<domains.domini[]> => {
      const result: domains.domini[] = await PersistentStore.getAll<domains.domini>(TABLES.tipiPianteSemeMarze) || [];
      const maxts: number = await PersistentStore.getMaxTs(TABLES.tipiPianteSemeMarze);
      domainService.getTipoPianteSemeMarze(maxts).then(async r => {
        replaceInArray(r, result, (a, b) => a.id === b.id);
        await PersistentStore.set(TABLES.tipiPianteSemeMarze, r);
      });
      return result;
    },

    trattamento: (state) => async (id: number): Promise<domains.domini> => {
      return await PersistentStore.get<domains.domini>(TABLES.trattamenti, id);
    },
    trattamenti: (state) => async (): Promise<domains.domini[]> => {
      const result: domains.domini[] = await PersistentStore.getAll<domains.domini>(TABLES.trattamenti) || [];
      const maxts: number = await PersistentStore.getMaxTs(TABLES.trattamenti);
      domainService.getTrattamento(maxts).then(async r => {
        replaceInArray(r, result, (a, b) => a.id === b.id);
        await PersistentStore.set(TABLES.trattamenti, r);
      });
      return result;
    },

    ubicazione: (state) => async (id: number): Promise<domains.domini> => {
      return await PersistentStore.get<domains.domini>(TABLES.ubicazioni, id);
    },
    ubicazioni: (state) => async (): Promise<domains.domini[]> => {
      const result: domains.domini[] = await PersistentStore.getAll<domains.domini>(TABLES.ubicazioni) || [];
      const maxts: number = await PersistentStore.getMaxTs(TABLES.ubicazioni);
      domainService.getUbicazione(maxts).then(async r => {
        replaceInArray(r, result, (a, b) => a.id === b.id);
        await PersistentStore.set(TABLES.ubicazioni, r);
      });
      return result;
    },

    statoVegetativo: (state) => async (id: number): Promise<domains.domini> => {
      return await PersistentStore.get<domains.domini>(TABLES.statiVegetativi, id);
    },
    statiVegetativi: (state) => async (): Promise<domains.domini[]> => {
      const result: domains.domini[] = await PersistentStore.getAll<domains.domini>(TABLES.statiVegetativi) || [];
      const maxts: number = await PersistentStore.getMaxTs(TABLES.statiVegetativi);
      domainService.getStatoVegetativo(maxts).then(async r => {
        replaceInArray(r, result, (a, b) => a.id === b.id);
        await PersistentStore.set(TABLES.statiVegetativi, r);
      });
      return result;
    },
  } as GetterTree<DomainStoreModel, DomainStoreGetters>,
  actions: {
    async setComposizioneVegetazionale(context, datas: domains.domini[]): Promise<void> {
      await PersistentStore.set(TABLES.composizioneVegetazionale, datas);
    },
    async setDanniOsservati(context, datas: domains.domini[]): Promise<void> {
      await PersistentStore.set(TABLES.danniOsservati, datas);
    },
    async setEsposzione(context, datas: domains.domini[]): Promise<void> {
      await PersistentStore.set(TABLES.esposizioni, datas);
    },
    async setFeriteTroncoCicatrizzazione(context, datas: domains.domini[]): Promise<void> {
      await PersistentStore.set(TABLES.feriteTroncoCicatrizzazione, datas);
    },
    async setFeriteTroncoDimensioni(context, datas: domains.domini[]): Promise<void> {
      await PersistentStore.set(TABLES.feriteTroncoDimensioni, datas);
    },
    async setFustiFibratura(context, datas: domains.domini[]): Promise<void> {
      await PersistentStore.set(TABLES.fustiFibratura, datas);
    },
    async setFustiNodosita(context, datas: domains.domini[]): Promise<void> {
      await PersistentStore.set(TABLES.fustiNodosita, datas);
    },
    async setFustiSezione(context, datas: domains.domini[]): Promise<void> {
      await PersistentStore.set(TABLES.fustiSezione, datas);
    },
    async setFustiTipo(context, datas: domains.domini[]): Promise<void> {
      await PersistentStore.set(TABLES.fustiTipo, datas);
    },
    async setGiaciture(context, datas: domains.domini[]): Promise<void> {
      await PersistentStore.set(TABLES.giaciture, datas);
    },
    async setGoverni(context, datas: domains.domini[]): Promise<void> {
      await PersistentStore.set(TABLES.governi, datas);
    },
    async setLettiere(context, datas: domains.domini[]): Promise<void> {
      await PersistentStore.set(TABLES.lettiere, datas);
    },
    async setOrigineMaterialiSelezionati(context, datas: domains.domini[]): Promise<void> {
      await PersistentStore.set(TABLES.origineMaterialiSelezionati, datas);
    },
    async setOriginePiantePlus(context, datas: domains.domini[]): Promise<void> {
      await PersistentStore.set(TABLES.originePiantePlus, datas);
    },
    async setOriginePopolamentiForestali(context, datas: domains.domini[]): Promise<void> {
      await PersistentStore.set(TABLES.originePopolamentiForestali, datas);
    },
    async setPietrosita(context, datas: domains.domini[]): Promise<void> {
      await PersistentStore.set(TABLES.pietrosita, datas);
    },
    async setPosizioniPiantePlus(context, datas: domains.domini[]): Promise<void> {
      await PersistentStore.set(TABLES.posizioniPiantePlus, datas);
    },
    async setPotaturePiantePlus(context, datas: domains.domini[]): Promise<void> {
      await PersistentStore.set(TABLES.potaturePiantePlus, datas);
    },
    async setSpecieArboree(context, datas: domains.domini[]): Promise<void> {
      await PersistentStore.set(TABLES.specieArboree, datas);
    },
    async setStruttureOrizzontali(context, datas: domains.domini[]): Promise<void> {
      await PersistentStore.set(TABLES.struttureOrizzontali, datas);
    },
    async setStruttureVerticali(context, datas: domains.domini[]): Promise<void> {
      await PersistentStore.set(TABLES.struttureVerticali, datas);
    },
    async setSubstratiPetrogenici(context, datas: domains.domini[]): Promise<void> {
      await PersistentStore.set(TABLES.substratiPetrogenici, datas);
    },
    async setTerreniSottostanti(context, datas: domains.domini[]): Promise<void> {
      await PersistentStore.set(TABLES.terreniSottostanti, datas);
    },
    async setTipiPiantePlus(context, datas: domains.domini[]): Promise<void> {
      await PersistentStore.set(TABLES.tipiPiantePlus, datas);
    },
    async setTipiPianteSemeMarze(context, datas: domains.domini[]): Promise<void> {
      await PersistentStore.set(TABLES.tipiPianteSemeMarze, datas);
    },
    async setTrattamenti(context, datas: domains.domini[]): Promise<void> {
      await PersistentStore.set(TABLES.trattamenti, datas);
    },
    async setUbicazioni(context, datas: domains.domini[]): Promise<void> {
      await PersistentStore.set(TABLES.ubicazioni, datas);
    },
    async setStatiVegetativi(context, datas: domains.domini[]): Promise<void> {
      await PersistentStore.set(TABLES.statiVegetativi, datas);
    },
  } as ActionTree<DomainStoreModel, DomainStoreActions>
}

export const domainStore = CreateTypedStoreProxy<DomainStoreModel, DomainStoreActions, DomainStoreGetters>(vuestore, DomainStore.PREFIX);